export default __webpack_public_path__ + "static/media/e17.24918a78.jpg";